import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeetingManagerService } from '../meeting-manager/lib/services/meeting-manager.service';
import { GlobalConstants } from '../meeting-manager/lib/global-constants';
import { Constants } from '../meeting-manager/lib/constants';
import { MeetingMapping } from '../meeting-manager/lib/mapping/meeting-mapping';
import { CommonService } from '../meeting-manager/lib/services/common.service';
import { MeetingTypeMapping } from '../meeting-manager/lib/mapping/meeting-type-mapping';
import { SnackbarService } from '../meeting-manager/lib/services/snackbar.service';
import { FormsModule } from '@angular/forms';
import { ForgeComponents } from 'app/forge-components';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ForgeComponents
  ],
  providers: [MeetingManagerService,
    GlobalConstants,
    Constants,
    MeetingMapping,
    MeetingTypeMapping,
    CommonService,
    SnackbarService],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class SharedMeetingManagerModule { }
